import apiClient from './apiClient';

// Authentication endpoints
export const authAPI = {
  signup: (email, password, displayName) =>
    apiClient.post('/auth/signup', { email, password, displayName }),
  
  login: (email, password) =>
    apiClient.post('/auth/login', { email, password }),
  
  getCurrentUser: () =>
    apiClient.get('/auth/me'),
  
  updateProfile: (data) =>
    apiClient.put('/auth/me', data),
  
  logout: () =>
    apiClient.post('/auth/logout')
};

// Product endpoints
export const productAPI = {
  getAll: (params) =>
    apiClient.get('/products', { params }),
  
  getById: (id) =>
    apiClient.get(`/products/${id}`),
  
  getReviews: (id) =>
    apiClient.get(`/products/${id}/reviews`)
};

// Cart endpoints
export const cartAPI = {
  getCart: () =>
    apiClient.get('/cart'),
  
  addToCart: (productId, quantity, price, name) =>
    apiClient.post('/cart/add', { productId, quantity, price, name }),
  
  updateQuantity: (productId, quantity) =>
    apiClient.put(`/cart/${productId}`, { quantity }),
  
  removeFromCart: (productId) =>
    apiClient.delete(`/cart/${productId}`),
  
  clearCart: () =>
    apiClient.delete('/cart')
};

// Order endpoints
export const orderAPI = {
  create: (items, totalPrice, shippingAddress, paymentMethod) =>
    apiClient.post('/orders', { items, totalPrice, shippingAddress, paymentMethod }),
  
  getAll: () =>
    apiClient.get('/orders'),
  
  getById: (orderId) =>
    apiClient.get(`/orders/${orderId}`),
  
  updateStatus: (orderId, status) =>
    apiClient.put(`/orders/${orderId}`, { status }),
  
  cancel: (orderId) =>
    apiClient.post(`/orders/${orderId}/cancel`)
};

// Payment endpoints
export const paymentAPI = {
  createStripeIntent: (amount, currency, orderId) =>
    apiClient.post('/payments/create-payment-intent', { amount, currency, orderId }),
  
  verifyStripePayment: (paymentIntentId) =>
    apiClient.post('/payments/verify-payment', { paymentIntentId }),
  
  createRazorpayOrder: (amount, currency, orderId) =>
    apiClient.post('/payments/create-razorpay-order', { amount, currency, orderId }),
  
  verifyRazorpayPayment: (orderId, paymentId, signature) =>
    apiClient.post('/payments/verify-razorpay-payment', { orderId, paymentId, signature }),
  
  createPaypalOrder: (amount, currency, orderId) =>
    apiClient.post('/payments/create-paypal-order', { amount, currency, orderId }),
  
  capturePaypalPayment: (orderId) =>
    apiClient.post('/payments/capture-paypal-payment', { orderId })
};

export default {
  authAPI,
  productAPI,
  cartAPI,
  orderAPI,
  paymentAPI
};
